/**
 *
 * StyledCardSection
 *
 */

import styled from 'styled-components';

import sizes from '../../assets/styles/sizes';
import colors from '../../assets/styles/colors';
import fonts from '../../assets/styles/fonts';

const StyledCardSection = styled.div`
  display: table;
  width: 100%;
  p {
    ${fonts.reg}
    font-size: 12px;
    color: ${colors.darkGrey};
    line-height: 10px;
    margin-top: ${sizes.margin * 0.6}px;
    &.description {
      line-height: 1.33;
      margin-top: ${sizes.margin * 0.6}px;
    }
  }
  .left-infos,
  .right-infos {
    display: inline-block;
  }
  .right-infos {
    vertical-align: top;
    float: right;
    div,
    p {
      width: 100%;
      text-align: right;
      font-weight: 600;
      margin-top: ${sizes.margin * 0.5}px;
    }
  }
  .bottom-infos {
    p {
      font-weight: 200;
    }
  }
  .description {
  }
`;

export default StyledCardSection;
